import React from 'react';
import { Stack } from '@mui/material';

import { Spinner } from '../Spinner';

import { ConditionalLoadingCardProps } from './props';

export const ConditionalLoadingCard: React.FC<ConditionalLoadingCardProps> = (
  props
) => {
  const { condition, children } = props;
  if (condition) {
    return (
      <Stack direction={'row'} justifyContent={'center'} alignItems={'center'}>
        <Spinner sx={{ padding: 8 }} />
      </Stack>
    );
  }
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

export default ConditionalLoadingCard;
